import { useMemo } from 'react'

export const TransferProgress = ({ transferData }) => {
  const queued = useMemo(
    () => {
      if (transferData.queued) {
        return true
      }

      return false
    },
    [transferData]
  )

  const precent = useMemo(
    () => {
      if (transferData.queued) {
        return `100%`
      }

      return transferData && transferData.progress ? `${transferData.progress.toFixed(0)}%` : '0%'
    },
    [transferData]
  )

  return (
    <div className="progress">
      <div className={`progress-bar ${queued && 'progress-bar-striped progress-bar-animated'}`} role="progressbar" style={{ width: precent }}>
        {queued ? 'queued' : precent}
      </div>
    </div>
  )
}
